<template>
  <InputField
    id="top-products-ranking-search"
    v-model="term"
    data-testid="top-products-ranking-search"
    maxlength="64"
    :placeholder="t('ProductTop100Ranking.search.placeholder')"
    @update:model-value="onInput"
    @clear="clear"
  >
    <template #prepend>
      <SearchIcon class="lucide-icon-s text-subtlest" />
    </template>
  </InputField>
</template>

<script setup lang="ts">
import { InputField } from '@ramp106/omrjs-core-ui'
import { SearchIcon } from '@ramp106/omrjs-core-ui/icons'
import { debounce } from 'lodash-es'
import { ref, watch } from 'vue'
import { useI18n } from 'vue-i18n'

const props = defineProps<{
  modelValue: string
}>()

const emit = defineEmits<{
  'update:modelValue': [value: string]
}>()

const { t } = useI18n()

const term = ref(props.modelValue)

watch(
  () => props.modelValue,
  (value) => {
    if (value !== term.value) {
      emitTerm.cancel()
      term.value = value
    }
  },
)

const MIN_SEARCH_LENGTH = 3

const emitTerm = debounce((value: string) => {
  const effective = value.trim().length >= MIN_SEARCH_LENGTH ? value : ''
  if (effective !== props.modelValue) emit('update:modelValue', effective)
}, 300)

function onInput(value: string) {
  emitTerm(value)
}

function clear() {
  term.value = ''
  emitTerm.cancel()
  if (props.modelValue !== '') emit('update:modelValue', '')
}
</script>
